(function(algolia) {
  'use strict';
  const render = algolia.externals.render;
  const html = algolia.externals.html;

  var algoliasearch = algolia.externals.algoliasearch;
  algolia.searchClient = algoliasearch(
          algolia.config.app_id,
          algolia.config.search_api_key
  );

  algolia.render = (template, container, data) => {
    return render(template(html, data), container);
  };

  var algoliasearch = algolia.externals.algoliasearch;
  algolia.searchClient = algoliasearch(
          algolia.config.app_id,
          algolia.config.search_api_key
  );

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(val) {
      return Number(val).toLocaleString();
    },
    displayPrice: function displayPrice(item, distinct) {
      if (distinct) {
        var min = item.variants_min_price;
        var max = item.variants_max_price;
        if (min !== max) {
          return  formatPrice(min) + ' - ' + formatPrice(max);
        }
      }
      return formatPrice(item.price);
    },
    displayStrikedPrice: function displayStrikedPrice(price, compare_at_price) {
      const comparing =
        Number(compare_at_price) && Number(compare_at_price) > Number(price);
      if (comparing) { return formatPrice(compare_at_price) }
    },
    displayDiscount: function displayDiscount(price, compare_at_price, price_ratio) {
      const comparing = Number(compare_at_price) && Number(compare_at_price) > Number(price);
      const discount_ratio = 1.0 - price_ratio;
      if (comparing) { return `${Math.round(discount_ratio * 100)}% Off`}
    },
    instantsearchLink: function instantsearchLink(hit) {
      if(hit._qsDistinct === false) {
          return (
            '/products/' +
            hit.handle + '?variant=' + hit.objectID);
      } else {
      const addVariantId = !hit._distinct && hit.objectID !== hit.id;
        return (
            '/products/' +
            hit.handle +
            (addVariantId ? '?variant=' + hit.objectID : '')
        );
      }
    },
    fullTitle: function fullTitle(title, distinct, variant_title) {
      var res = title;
      if (
        !distinct &&
        variant_title &&
        variant_title !== 'Default Title' &&
        variant_title !== 'Default'
      ) {
        res += ' (' + variant_title + ')';
      }

      return escapeHtml(res);
    },
    variantTitleAddition: function variantTitleAddition(item, distinct) {
      var res = ' ';
      if (
        !distinct &&
        item.variant_title &&
        item.variant_title !== 'Default Title' &&
        item.variant_title !== 'Default'
      ) {
        res += `( ${item.variant_title} )`;
      }
      return res;
    },
    hexToRGB: function hexToRGB(hex){
      if (!hex) return ``;
      if(hex.length== 4){
        hex = hex.substring(1).replace(/./g, '$&$&')
      }
      var m = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
      return `${parseInt(m[1], 16)},${parseInt(m[2], 16)},${parseInt(m[3], 16)}`;
    },
    sizedImage: function sizedImage(sizeInput, item, _distinct) {
      var image = _distinct ? item.product_image : item.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = sizeInput.replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    }
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original'
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = function(item) {
        var image = item.product_image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    };
  });
})(window.algoliaShopify);
